import { createSlice } from '@reduxjs/toolkit';

type IData1 = {
  created_at: Date;
  id: string;
  name_ru: null;
  name_uz: string;
  type: string;
  upper_group_id: string;
};
type IData2 = {
  db_id: null;
  file: {};
  file_id: string;
  group_id: string;
  group_type: string;
  id: string;
  name_ru: string;
  name_uz: string;
};

type RequestCommandState = {
  loading: boolean;
  orderGroup: IData1[];
  templateList: IData2[];
};

const initialState: RequestCommandState = {
  loading: false,
  orderGroup: [],
  templateList: [],
};

export const internalGroupSlice = createSlice({
  name: 'internalGroup',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setOrderGroup: (state, action) => {
      // @ts-ignore
      state.orderGroup = action.payload;
    },
    setTemplateList: (state, action) => {
      state.templateList = action.payload;
    },
  },
});

export default internalGroupSlice.reducer;
